import {STALE_TIME_50_MIN} from '@common/constants/time';
import {useAuthStore} from '@common-web/stores/authStore';
import {trpc} from '@common-web/lib/trpc';

/** Resolves the current user's avatar URL (presigned S3 URL, or `undefined` when none set). */
export function useUserAvatarUrl() {
  const user = useAuthStore((s) => s.user);
  const {data, isLoading} = trpc.user.profile.getAvatarUrl.useQuery(undefined, {
    enabled: !!user?.id,
    staleTime: STALE_TIME_50_MIN, // presigned URLs expire after 1 hour; refresh at 50 min
  });

  return {
    avatarUrl: data?.url ?? undefined,
    isLoading,
  };
}
